import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { KngUploadFile, KngUploadFileState } from './definitions';
import { KngUploadFileService } from './kng-upload-file.service';
import { KngLoaderState } from '../loader';
import { LibIcons } from '../../constants/global.constant';

@Component({
	selector: 'kng-upload-file',
	templateUrl: './template/kng-upload-file.component.html',
	styleUrls: ['./template/kng-upload-file.component.scss']
})
export class KngUploadFileComponent implements KngUploadFile, OnInit, OnDestroy 
{

	private subscriptions: Subscription = new Subscription();
	files: File[] = [];
	loaderState: KngLoaderState = { imagePath: LibIcons.widgetLoader };
	fileUploadLoaderState : KngLoaderState = { imagePath: LibIcons.loaderWithOutText };

	@Input() set state(value: KngUploadFileState) 
	{
		this.service.updateState(value);
	}
	get state(): KngUploadFileState 
	{
		return this.service.state;
	}
	
	@Output() stateChanged: EventEmitter<KngUploadFileState> = new EventEmitter<KngUploadFileState>();
	@Output() fileValidationCheck: EventEmitter<File> = new EventEmitter<File>();
	@Output() tryAgainEventEmitter: EventEmitter<File> = new EventEmitter<File>();
	@Output() replaceFileEventEmitter: EventEmitter<void> = new EventEmitter<void>();

	constructor(private service: KngUploadFileService) { }

	ngOnInit(): void 
	{
		this.initSubscriptions();
	}
	ngOnDestroy(): void 
	{
		this.destroySubscriptions();
	}
	private initSubscriptions(): void 
	{
		const stateChangeSubs: Subscription = this.service.stateChanged.subscribe((next: KngUploadFileState) => this.stateChanged.emit(next));
		this.subscriptions.add(stateChangeSubs);
	}
	private destroySubscriptions(): void 
	{
		this.subscriptions.unsubscribe();
	}
	onFileDropped(filedropped: FileList) 
	{
		this.fileUpdateHandle(Array.from(filedropped));
	}
	fileBrowseHandler(event: Event) 
	{
		this.fileUpdateHandle(Array.from((event.target as HTMLInputElement).files as FileList));
	}
	fileUpdateHandle(files: Array<File>) 
	{
		this.state.isError = false;	
		this.fileValidationCheck.emit(files[0]);
	}
	onReplaceFileBtnClick()
	{
		this.state.isError = false;
		this.state.isSuccessClient = true;
		this.state.isSuccessServer = false;
		this.replaceFileEventEmitter.emit();
	}
	onTryAgainBtnClick()
	{
		this.tryAgainEventEmitter.emit(this.files[0]);
	}
	
}
